import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Clock from "./components/Clock/Clock";
import ButtonsMenu from "./components/MainScreen/ButtonsMenu";
import "./App.css";

function App() {
    const [userRole, setUserRole] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Проверяем роль пользователя при загрузке компонента
        const role = localStorage.getItem('lg_userRole');
        const user = localStorage.getItem('lg_username');

        console.log('App.jsx - Checking auth:');
        console.log('lg_userRole:', role);
        console.log('lg_username:', user);

        if (role && user) {
            setUserRole(role);
            console.log('User authenticated:', user, 'Role:', role);
        } else {
            console.log('No auth found, redirecting to login');
            navigate('/');
        }
    }, [navigate]);

    if (!userRole) {
        return (
            <div className="loading-container">
                <div className="spinner"></div>
                <p>Проверка авторизации...</p>
            </div>
        );
    }

    return (
        <div className="home-screen">
            <div className="main-container">
                <div className="clock-container">
                    <Clock />
                </div>
                <ButtonsMenu />
            </div>
        </div>
    );
}

export default App;